import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconCheckmarkSmall(props: IconProps) {
  return (
    <BaseIcon {...props} size={16} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7745 4.83356C12.0506 5.07722 12.0768 5.49851 11.8331 5.77454L6.53685 11.7745C6.40619 11.9226 6.21666 12.005 6.0193 11.9998C5.82195 11.9945 5.63707 11.9021 5.51448 11.7473L3.47744 9.1759C3.24881 8.88729 3.29743 8.46799 3.58604 8.23937C3.87464 8.01074 4.29394 8.05936 4.52257 8.34797L6.06469 10.2946L10.8335 4.89218C11.0772 4.61615 11.4985 4.5899 11.7745 4.83356Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
